export const findServerNodes = [
  {
    id: "60.150.25.71",
    type: "custom",
    position: { x: 90, y: 130 },
    className: "mobil",
    data: { label: "60.150.25.71" },
    dragHandle: "noDrag",
  },
  {
    id: "104.169.110.92",
    type: "custom",
    position: { x: 90, y: 280 },
    className: "mobil",
    data: { label: "104.169.110.92" },
    dragHandle: "noDrag",
  },
  {
    id: "99.133.116.181",
    type: "custom",
    position: { x: 90, y: 420 },
    className: "mobil",
    data: { label: "99.133.116.181" },
    dragHandle: "noDrag",
  },
  {
    id: "81.119.95.47",
    type: "default",
    position: { x: 260, y: 130 },
    className: "gateway",
    data: { label: "81.119.95.47" },
    dragHandle: "noDrag",
  },
  {
    id: "34.239.245.172",
    type: "default",
    position: { x: 260, y: 420 },
    className: "gateway",
    data: { label: "34.239.245.172" },
    dragHandle: "noDrag",
  },
  {
    id: "155.177.229.194",
    type: "default",
    position: { x: 470, y: 420 },
    className: "gateway",
    data: { label: "155.177.229.194" },
    dragHandle: "noDrag",
  },
  {
    id: "203.212.60.217",
    type: "default",
    position: { x: 470, y: 130 },
    className: "gateway",
    data: { label: "203.212.60.217" },
    dragHandle: "noDrag",
  },
  {
    id: "60.40.118.216",
    type: "default",
    position: { x: 365, y: 280 },
    className: "gateway",
    data: { label: "60.40.118.216" },
    dragHandle: "noDrag",
  },
  {
    id: "5.10.40.25",
    type: "default",
    position: { x: 650, y: 130 },
    className: "server-plain",
    data: { label: "5.10.40.25" },
    dragHandle: "noDrag",
  },
  {
    id: "51.251.205.152",
    type: "default",
    position: { x: 650, y: 280 },
    className: "server-plain",
    data: { label: "51.251.205.152" },
    dragHandle: "noDrag",
  },
  {
    id: "199.38.67.227",
    type: "default",
    position: { x: 650, y: 420 },
    className: "server-plain",
    data: { label: "199.38.67.227" },
    dragHandle: "noDrag",
  },
];
